import React from 'react';
import { connect } from "react-redux";
import { setPassword, removeErrorMsg } from '../../action/user';
import queryString from 'query-string';
import * as Env from '../../env';

function mapStateToProps(state) {
  return state;
}

const mapDispatchToProps = {
  setPassword,
  removeErrorMsg
};

class Signup extends React.Component {

  constructor(props) {
    super(props);
    let url = window.location.href;
    let params = queryString.parse(url);

    this.state = {
      first_name: '',
      last_name: '',
      email: '',
      token: params.token
    }
  }
  emailChange(e) {
    this.setState({
      email: e.currentTarget.value,
      password: this.state.password,
      confirm_password: this.state.confirm_password,
      token: this.state.token
    });
    this.props.removeErrorMsg();
  }

  passwordChange(e) {
    this.setState({
      email: this.state.email,
      password: e.currentTarget.value,
      confirm_password: this.state.confirm_password,
      token: this.state.token

    });
    this.props.removeErrorMsg();
  }

  confirmPasswordChange(e) {
    this.setState({
      email: this.state.email,
      password: this.state.password,
      confirm_password: e.currentTarget.value,
      token: this.state.token
    });
    this.props.removeErrorMsg();
  }


  handleClick(e) {
    console.log(this.state);
    this.props.setPassword(this.state);
  }

  onSignInClick() {
    window.location.href = Env.APP;
  }
  render() {
    const errors = this.props.loginView.errors;
    const server_errors = this.props.loginView.server_errors;
    const server_error_str = server_errors ? server_errors.map((error, key) =>
      <div className="error-img-div" key={key}>
        <img src="/img/error_icon.svg" alt="Error Icon" className="error-icon"></img>{error}
      </div>
    ) : "";
    return (
      <div className="Signup login-system">
        <div className="white-background">
        <img src="/img/arrow-left.svg" alt="Arrow Left" className="arrow-left big clickable" onClick={this.onSignInClick.bind(this)}/>
          {server_errors ?
            <div className="error-div">
              {server_error_str}
            </div> : ""}
          
            <div className="sign-in-box">
              <h1>Setup Password</h1>
              <h5>Please set up your password</h5>
              <input name="email" type="email" placeholder="Email Address" onChange={this.emailChange.bind(this)}></input>
              {errors && errors.email ?
                <div className="error-img-div float-right">
                  <img src="/img/error_icon.svg" alt="Error Icon" className="error-icon"></img>{errors.email}
                </div> : ""}
              <input name="password" type="password" placeholder="Password" onChange={this.passwordChange.bind(this)}></input>
              {errors && errors.password ?
                <div className="error-img-div float-right">
                  <img src="/img/error_icon.svg" alt="Error Icon" className="error-icon"></img>{errors.password}
                </div> : ""}
              <input name="confirm_password" type="password" placeholder="Confirm Password" onChange={this.confirmPasswordChange.bind(this)}></input>
              {errors && errors.confirm_password ?
                <div className="error-img-div float-right">
                  <img src="/img/error_icon.svg" alt="Error Icon" className="error-icon"></img>{errors.confirm_password}
                </div> : ""}
              <div className="button-div">
                <button onClick={this.handleClick.bind(this)}>Set Password</button>
              </div>
            </div>
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Signup);
